import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDListItem, TSDSimulatorPNLinkingResultPayload, TSDSimulatorPNLinkingResultPayloadSchema } from '@e-origin/contracts';

interface UseSimulatorFormInitializerProps {
  tsd: TSDListItem;
  onHide(): void;
  onSubmit(payload?: Record<string, unknown>): Promise<void> | void;
}

export const useSimulateTsdPNLinkingResultFormInitializer = ({ onHide, onSubmit }: UseSimulatorFormInitializerProps) => {
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<TSDSimulatorPNLinkingResultPayload>({
    mode: 'controlled',
    initialValues: {
      status: '04',
    },
    validate: zodResolver(TSDSimulatorPNLinkingResultPayloadSchema),
    validateInputOnBlur: true,
  });

  const onSubmitForm = async (values: TSDSimulatorPNLinkingResultPayload) => {
    try {
      setSubmitting(true);

      await onSubmit({
        status: values.status,
      });
    } catch {
      // toast handled by mutation
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return {
    form,
    onSubmit: onSubmitForm,
    submitting,
  };
};
